import { Flame, CheckCircle2, Circle } from "lucide-react";
import { Card } from "@/components/ui/card";

/**
 * HabitStreakCard — visão geral de hábitos: check-ins de hoje +
 * top streaks. Renderiza payload de backend build_habit_streak.
 */
export default function HabitStreakCard({ data }) {
  const total = data?.total_active ?? 0;
  const checked = data?.checked_today ?? 0;
  const pct = data?.completion_pct ?? 0;
  const top = data?.top_streaks || [];

  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="text-xs text-foreground-muted mb-2">Seus hábitos</div>

      {/* KPIs topo */}
      <div className="grid grid-cols-3 gap-2 mb-3">
        <div className="flex flex-col items-center gap-1 py-2 px-3 rounded-lg bg-surface-card-hover">
          <CheckCircle2 className="w-4 h-4 text-emerald-400" />
          <div className="text-lg font-bold text-foreground leading-none">
            {checked}/{total}
          </div>
          <div className="text-[10px] text-foreground-muted text-center">Feitos hoje</div>
        </div>
        <div className="flex flex-col items-center gap-1 py-2 px-3 rounded-lg bg-surface-card-hover">
          <Circle className="w-4 h-4 text-indigo-400" />
          <div className="text-lg font-bold text-foreground leading-none">{pct}%</div>
          <div className="text-[10px] text-foreground-muted text-center">Completion</div>
        </div>
        <div className="flex flex-col items-center gap-1 py-2 px-3 rounded-lg bg-surface-card-hover">
          <Flame className="w-4 h-4 text-orange-400" />
          <div className="text-lg font-bold text-foreground leading-none">
            {data?.best_streak ?? 0}d
          </div>
          <div className="text-[10px] text-foreground-muted text-center">Melhor streak</div>
        </div>
      </div>

      {/* Top streaks */}
      {top.length > 0 && (
        <div className="space-y-1">
          <div className="text-[10px] text-foreground-muted uppercase tracking-wider mb-1">
            Top streaks
          </div>
          {top.slice(0, 5).map((h) => (
            <div
              key={h.name}
              className="flex items-center justify-between py-1.5 px-3 rounded-lg bg-surface-card-hover"
            >
              <div className="flex items-center gap-2 min-w-0 mr-2">
                {h.checked_today ? (
                  <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0" />
                ) : (
                  <Circle className="w-3.5 h-3.5 text-foreground-muted flex-shrink-0" />
                )}
                <div className="text-xs text-foreground truncate">{h.name}</div>
              </div>
              <div className="flex items-center gap-1 text-[10px] text-foreground-muted whitespace-nowrap">
                <Flame className="w-3 h-3 text-orange-400" />
                {h.streak_current}d
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
